export default class SpreadSheetModel {
    constructor(spreadSheetData) {
        this.sheetData = spreadSheetData.sheets
        this.sheetTitles = this._sheetTitles()
    }

    _sheetTitles() {
        return this.sheetData.map(s => {
            return s.properties.title
        })
    }
}